import styled from 'styled-components'

export const StyleDownload = styled.div`
  @media screen and (min-width: 300px) and (max-width: 768px) {
    display: none;
  }
`
